"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NightsPickerRangeDesktop", {
  enumerable: true,
  get: function get() {
    return _NightsPickerRange.NightsPickerRangeDesktop;
  }
});
Object.defineProperty(exports, "NightsPickerRangeMobile", {
  enumerable: true,
  get: function get() {
    return _NightsPickerRange2.NightsPickerRangeMobile;
  }
});
exports.TYPES = void 0;
var _NightsPickerRange = require("./components/NightsPickerRange.desktop");
var _NightsPickerRange2 = require("./components/NightsPickerRange.mobile");
var _TYPES = _interopRequireWildcard(require("./types"));
exports.TYPES = _TYPES;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }